export enum CampaignActivityKind {
  System = "system",
  Comment = "comment",
}

export enum CampaignActivityAction {
  StageTransition = "stage_transition",
  ShipmentSet = "shipment_set",
  ContentUrlSet = "content_url_set",
  TagsSet = "tags_set",
  ProductSelectionSet = "product_selection_set",
  RejectedSet = "rejected_set",
  Unrejected = "unrejected",
  CreatorsAdded = "creators_added",
  SettlementMarked = "settlement_marked",
  SettlementUnmarked = "settlement_unmarked",
  SettlementMetaUpdated = "settlement_meta_updated",
}

// Why a stage moved; Facade writes it as payload.cause on stage_transition logs.
export const STAGE_TRANSITION_CAUSES = {
  Manual: "manual",
  CreatorConfirmedShipping: "creator_confirmed_shipping",
  MarketingOrderShipped: "marketing_order_shipped",
  MarketingOrderDelivered: "marketing_order_delivered",
  ContentSubmitted: "content_submitted",
  AffiliateCodeIssued: "affiliate_code_issued",
  BrandPick: "brand_pick",
} as const;

export type StageTransitionCause =
  (typeof STAGE_TRANSITION_CAUSES)[keyof typeof STAGE_TRANSITION_CAUSES];

export interface CampaignActivityLog {
  campaignId: string;
  influencerId: string;
  logId: string;
  kind: CampaignActivityKind;
  action?: CampaignActivityAction;
  fromStage?: string;
  toStage?: string;
  body?: string;
  payload?: Record<string, unknown>;
  authorId?: string;
  createdAt: string;
  updatedAt?: string;
  deletedAt?: string;
}

export interface TimelineQueryOptions {
  limit?: number;
  olderThan?: string;
}

export interface AddCommentRequest {
  body: string;
  authorId: string;
}

export interface EditCommentRequest {
  body: string;
  editorId: string;
}

export interface DeleteCommentRequest {
  editorId: string;
}

export const DEFAULT_TIMELINE_LIMIT = 50;
export const MAX_TIMELINE_LIMIT = 200;
